import { Navigate, useLocation } from 'react-router-dom'
import UserPool from '../pages/auth/UserPool'

interface LicenseGuardProps {
    routeType: 'student' | 'commercial'
    children: JSX.Element
}

const LicenseGuard = ({ routeType, children }: LicenseGuardProps) => {
    const location = useLocation()
    const currentUser = UserPool.getCurrentUser()
    const userType = localStorage.getItem('isStudentUser') // 'true' or 'false'
    const isBlockedUser = localStorage.getItem('isBlockedUser') === 'true'

    // Blocked user
    if (isBlockedUser) {
        return <Navigate to='/' replace />
    }

    // If user is already logged in and tries to access /student-licenses or /commercial-licenses, redirect to dashboard
    const isStudentRoute = location.pathname === '/student-licenses'
    const isCommercialRoute = location.pathname === '/commercial-licenses'
    // const isLoggedIn = !!localStorage.getItem('token') // or use your actual auth check

    if (currentUser && (isStudentRoute || isCommercialRoute)) {
        return <Navigate to='/' replace />
    }

    // Existing logic for routeType (optional, can be removed if above covers all cases)
    if (routeType === 'student' && userType !== 'true') {
        return <Navigate to='/' replace />
    }
    if (routeType === 'commercial' && userType === 'true') {
        return <Navigate to='/' replace />
    }

    return children
}

export default LicenseGuard
